import { Badge } from "@light-technology/components";
import { isFuture, isWithinInterval } from "date-fns";
import type { LocationDocument } from "../../state/api.types";

type ContractStatusProps = { contract: LocationDocument };

export const ContractStatus = (props: ContractStatusProps) => {
  if (
    isWithinInterval(new Date(), {
      start: props.contract.contract_start,
      end: props.contract.contract_end,
    })
  ) {
    return (
      <Badge color="gray" size="sm" type="pill-color">
        Current
      </Badge>
    );
  }
  if (isFuture(props.contract.contract_start)) {
    return (
      <Badge color="gray" size="sm" type="pill-color">
        Upcoming
      </Badge>
    );
  }
  return null;
};
